"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMinutePerformanceLoading = exports.useMinutePerformanceError = exports.useMinutePerformance = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _minutePerformance = require("../reducers/minutePerformance");

var useMinutePerformance = function useMinutePerformance(prospectId, startDate, endDate, baseUrl, authToken) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var minutePerformance = (0, _reactRedux.useSelector)((0, _minutePerformance.getMinutePerformance)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl) {
      dispatch((0, _minutePerformance.fetchMinutePerformanceIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, baseUrl, authToken]);
  return minutePerformance;
};

exports.useMinutePerformance = useMinutePerformance;

var useMinutePerformanceLoading = function useMinutePerformanceLoading() {
  var minutePerformanceLoading = (0, _reactRedux.useSelector)(_minutePerformance.getMinutePerformanceLoading);
  return minutePerformanceLoading;
};

exports.useMinutePerformanceLoading = useMinutePerformanceLoading;

var useMinutePerformanceError = function useMinutePerformanceError() {
  var minutePerformanceError = (0, _reactRedux.useSelector)(_minutePerformance.getMinutePerformanceError);
  return minutePerformanceError;
};

exports.useMinutePerformanceError = useMinutePerformanceError;